<template>
  <div class="root">
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="标题：" required>
        <el-input v-model="form.title" style="font-size: 22px"></el-input>
      </el-form-item>
      <el-form-item label="姓名：" required>
        <el-input v-model="form.realname" style="font-size: 22px"></el-input>
      </el-form-item>
      <el-form-item label="电话：" required>
        <el-input v-model="form.phone" style="font-size: 22px"></el-input>
      </el-form-item>

      <el-form-item label="内容：" required>
        <el-input type="textarea" v-model="form.content" style="font-size: 22px"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="onSubmit">
          <img src="../assets/img/按钮.png" />
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from '../util/request';

export default {
  data() {
    return {
      form: {
        timestamp: "",
        random: "",
        sign: "",
        title: "",
        realname: "",
        phone: "",
        content: "",
        type: '3'
      },
    };
  },
  created() {
    this.form.timestamp = this.timestamp;
    this.form.random = this.numRandom;
    this.form.sign = this.mainSign;
  },
  mounted() { },
  computed: {},
  watch: {},
  methods: {
    onSubmit() {

      // console.log(this.form);


      // 提交投诉建议
      // let url = 'tijiaotousuyujianyi';
      let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/; //正则表达式定义手机号正确格式
      let regPhone = new RegExp(reg);
      if (this.form.phone && !regPhone.test(this.form.phone)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning",
        });
        return
      }

      if (
        this.form.title &&
        this.form.realname &&
        this.form.content
      ) {

        // let ss = this.ajax_data(url, this.form);
        request({
          url: '/base/advise',
          data: this.form,
          method: 'post',
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        }).then(res => {
          // 注册提示
          console.log(res)
          if (res.data.code == 200) {
            this.$message({
              message: '提交成功',
              type: "success",
            });
            this.form = {
              timestamp: "",
              random: "",
              sign: "",
              title: "",
              realname: "",
              phone: "",
              content: "",
            };

          } else {
            this.$message({
              message: '提交失败',
              type: "error",
            });
          }
        })
      } else {

        this.$message({
          message: "请输入必填项",
          type: "warning",
        });
      }
      // console.log(this.timestamp);
      // console.log(this.numRandom);
      // console.log(this.mainSign);
    },
  },
};
</script>

<style scoped>
.root {
  min-height: 1180px;
  margin: 0 auto;
  margin-bottom: 30px;
  padding: 40px 280px 80px 280px;
  width: 1300px;
  height: auto;
  background: #ffffff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
}

.el-form-item /deep/ .el-form-item__label {
  height: 40px;
  font-size: 23px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #333333;
  letter-spacing: 5px;
}

.el-form-item {
  margin-bottom: 40px;
}

.el-textarea /deep/ .el-textarea__inner {
  height: 300px;
}

.el-button {
  display: block;
  padding: 0;
  margin: 0 auto;
}
</style>
